module.exports = __webpack_public_path__ + "static/media/people_working.e6aa5811.mp4";